var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    class: _vm.elementClass,
    attrs: {
      "href": _vm.url,
      "target": _vm.target ? _vm.target : undefined
    }
  }, [_c('div', {
    staticClass: "dashboard-button-icon"
  }, [_vm._t("icon", function () {
    return [_c('svg', {
      attrs: {
        "width": "58",
        "height": "40",
        "viewBox": "0 0 58 40",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M37.8855 19.5938C37.8855 24.5125 33.898 28.5 28.9792 28.5C24.0605 28.5 20.073 24.5125 20.073 19.5938C20.073 14.675 24.0605 10.6875 28.9792 10.6875C33.898 10.6875 37.8855 14.675 37.8855 19.5938Z",
        "fill": "black"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M0.479248 19.5938C0.479248 19.5938 11.1667 0 28.9792 0C46.7917 0 57.4792 19.5938 57.4792 19.5938C57.4792 19.5938 46.7917 39.1875 28.9792 39.1875C11.1667 39.1875 0.479248 19.5938 0.479248 19.5938ZM28.9792 32.0625C35.8655 32.0625 41.448 26.4801 41.448 19.5938C41.448 12.7074 35.8655 7.125 28.9792 7.125C22.0929 7.125 16.5105 12.7074 16.5105 19.5938C16.5105 26.4801 22.0929 32.0625 28.9792 32.0625Z",
        "fill": "black"
      }
    })]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-weight": "600",
        "margin": "0.375rem 0 0.625rem 0"
      }
    }, [_vm._v("\n        ObservNow™\n      ")])];
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "full-height-centered-flex-col"
  }, [_c('p', {
    staticClass: "margin-auto"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n      "), _c('i', {
    staticClass: "fas fa-chevron-right"
  }, [_c('svg', {
    attrs: {
      "width": "18px",
      "height": "18px",
      "viewBox": "0 0 512 512",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("chevron-right")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "add",
      "fill": "#000000",
      "transform": "translate(149.333333, 80.853333)"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Path",
      "points": "-2.84217094e-14 320 30.1698893 350.169889 205.254834 175.084945 30.1698893 0 -2.84217094e-14 30.1698893 144.898278 175.084945"
    }
  })])])])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }